module.exports = __webpack_public_path__ + "assets/images/KYD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/KYD50.png
// module id = 1416
// module chunks = 1